import {
  Box,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  styled,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";

// svg
import { ReactComponent as IconTooltip } from "../../assets/svg/help-circle.svg";
import { ReactComponent as IconReload } from "../../assets/svg/reload.svg";
import { usePlannerContext } from "../../services/context/planner-context";
import {
  connectionTypes,
  connectionTypesList,
  functionalTypesId,
} from "../../constants/planner.constants";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.background.default,
    fontSize: 12,
    /*   boxShadow: theme.shadows[1],
     fontSize: 11 */
  },
}));

export const SelectConnectionType = ({
  label,
  value,
  connectionId,
}) => {
  const { edges, setEdges } = usePlannerContext();

  const handleChangeType = (e) => {
    const selectedOption = e.target.value;
    setEdges((eds) =>
      eds.map((item) => {
        if (item.id === connectionId) {
          return {
            ...item,
            data: {
              ...item.data,
              label: connectionTypes[selectedOption].name,
              connectionType: selectedOption,
            },
          };
        } else {
          return item;
        }
      })
    );
  };

  return (
    <FormControl sx={{ width: "100%" }}>
      <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "2px",
            /* mb: "4px", */
            padding: "0px 0px 0px 8px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography
              sx={{
                fontSize: "12px",
                color: "#343745",
                fontWeight: 500,
                lineHeight: 1.9,
              }}
            >
              Connection Type
            </Typography>
            <LightTooltip title={"tooltip text"} placement="right">
              <IconTooltip width="14px" height="14px" stroke="#dbdbeb" />
            </LightTooltip>
          </Box>
          {/* {loading && <CircularProgress size={15} />} */}
          {/* {error && (
          <IconButton sx={{ padding: "4px" }} onClick={reloadHandler}>
            <IconReload stroke="#ba1a1a" width={"14px"} height={"14px"} />
          </IconButton>
        )} */}
        </Box>

        <Select
          value={value}
          onChange={handleChangeType}
          name={"connection type"}
          size="small"
          className="nodrag nopan"
          sx={{
            fontSize: "14px",
            "& .MuiSelect-select": {
              padding: "8.5px 8px",
            },
            "&.MuiInputBase-root": {
              borderRadius: "8px",
              background: "#fff",
            },
            "&.MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#dbdbeb",
                borderWidth: "1px",
                transition:
                  "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
              },
              "&:hover fieldset": {
                borderColor: "#efa21e",
                borderWidth: "1px",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#efa21e",
                borderWidth: "1px",
              },
            },
          }}
        >
          {connectionTypesList.map((item) => (
            <MenuItem
              key={item}
              value={item}
              /* disabled={
                type !== "carparking" && item === "Car Parking Area"
                  ? hasCarPark
                  : type === "carparking" && item !== "Car Parking Area"
                  ? buildingsCount >= 10
                  : false
              } */
            >
              {connectionTypes[item].name}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </FormControl>
  );
};
